export function initAutocomplete(_google, input, isoCountyCode, onPlace) {
    const autocomplete = new _google.maps.places.Autocomplete(input, {
        types: ["address"],
    });
    autocomplete.setFields(["address_component"]);
    autocomplete.setComponentRestrictions({
        country: [isoCountyCode],
    });
    autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        onPlace?.(place);
    });
}
//# sourceMappingURL=initAutocomplete.js.map